import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { Button } from 'module-tsl-ui-elements';
import AuthHelper, { actions, getJobStatus, isUserLoggedIn, track } from './helpers';
var apiUrl = '/api/jobs/savedjobs';
export var SaveJobButton = function SaveJobButton(props) {
  var jobId = props.jobId,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {
    country: 'gb'
  } : _props$i18n,
      _props$iconOnly = props.iconOnly,
      iconOnly = _props$iconOnly === void 0 ? false : _props$iconOnly,
      _props$mediaPartnerSo = props.mediaPartnerSource,
      mediaPartnerSource = _props$mediaPartnerSo === void 0 ? {} : _props$mediaPartnerSo,
      _props$position = props.position,
      position = _props$position === void 0 ? 'job' : _props$position,
      _props$shouldPubSub = props.shouldPubSub,
      shouldPubSub = _props$shouldPubSub === void 0 ? false : _props$shouldPubSub,
      _props$savedLabel = props.savedLabel,
      savedLabel = _props$savedLabel === void 0 ? 'Saved to My Jobs' : _props$savedLabel,
      _props$unsavedLabel = props.unsavedLabel,
      unsavedLabel = _props$unsavedLabel === void 0 ? 'Save for later' : _props$unsavedLabel,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size;

  var _useState = useState(isUserLoggedIn()),
      _useState2 = _slicedToArray(_useState, 2),
      isLoggedIn = _useState2[0],
      setIsLoggedIn = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSaved = _useState6[0],
      setIsSaved = _useState6[1];

  var _useState7 = useState(unsavedLabel),
      _useState8 = _slicedToArray(_useState7, 2),
      content = _useState8[0],
      setContent = _useState8[1];

  var _useState9 = useState('tds-bookmark-filled'),
      _useState10 = _slicedToArray(_useState9, 2),
      icon = _useState10[0],
      setIcon = _useState10[1];

  var updateSaveState = function updateSaveState(saved) {
    setIsSaved(saved);
    setIcon(saved ? 'tds-bookmark-filled' : 'tds-bookmark');
    setContent(saved ? savedLabel : unsavedLabel);
    setIsLoading(false);
  };

  var handleEvent = function handleEvent(event, state) {
    if (shouldPubSub) {
      actions.trigger(event, state, jobId);
    } else {
      event === 'loading' ? setIsLoading(state) : updateSaveState(state);
    }
  };

  var loadEvent = function loadEvent(e, id, state) {
    if (jobId === id) {
      setIsLoading(state);
    }
  };

  var saveEvent = function saveEvent(e, id, state) {
    if (jobId === id) {
      updateSaveState(state);
    }
  };

  var saveJob = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var mediaSource, partner, _ref2, _ref3, match, csrfToken, url, response, saved, eventTitle;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleEvent('loading', true);
              mediaSource = mediaPartnerSource.mediaSource, partner = mediaPartnerSource.partner;
              _ref2 = document.cookie.match(/csrf=([^;]*)/) || [], _ref3 = _slicedToArray(_ref2, 2), match = _ref3[0], csrfToken = _ref3[1]; // eslint-disable-line no-unused-vars

              url = "".concat(apiUrl).concat(isSaved ? "/".concat(jobId) : "?siteCountry=".concat(i18n.country));
              _context.prev = 4;
              _context.next = 7;
              return fetch(url, {
                method: isSaved ? 'DELETE' : 'POST',
                headers: {
                  'x-csrf-token': csrfToken,
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  jobId: jobId,
                  partner: partner,
                  mediaSource: mediaSource
                })
              });

            case 7:
              response = _context.sent;
              saved = response.status === 201;
              eventTitle = saved ? 'save-job' : 'forget-job';
              track(eventTitle, jobId, position);
              handleEvent('save', saved);
              _context.next = 19;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              handleEvent('save', false);
              setIcon('tds-bookmark');
              setContent('Save failed');

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }));

    return function saveJob() {
      return _ref.apply(this, arguments);
    };
  }();

  var authenticate = new AuthHelper(function () {
    return track('save-job-button', jobId, position);
  }, function () {
    return saveJob();
  }, function () {
    return getJobStatus(apiUrl, jobId, updateSaveState);
  });

  var subscribe = function subscribe() {
    actions.add('loading', loadEvent);
    actions.add('save', saveEvent);
  };

  var unsubscribe = function unsubscribe() {
    actions.remove('loading', loadEvent);
    actions.remove('save', saveEvent);
  };

  useEffect(function () {
    shouldPubSub && subscribe();

    if (isLoggedIn) {
      getJobStatus(apiUrl, jobId, updateSaveState);
    } else {
      setIsLoggedIn(authenticate.listenForLogin());
      updateSaveState(false);
    }

    return function () {
      // this callback gets implemented before the component is removed from the UI
      shouldPubSub && unsubscribe();
    };
  }, [isLoggedIn]);
  return /*#__PURE__*/React.createElement(Button, {
    className: "tds-save-job-button tds-btn--with-icon",
    theme: iconOnly ? 'tertiary' : props.theme || 'secondary',
    loading: isLoading,
    onClick: function onClick() {
      return authenticate.actionIfLoggedIn();
    },
    isBlock: props.isBlock,
    iconRight: true,
    icon: icon,
    size: size
  }, !iconOnly && content);
};
SaveJobButton.displayName = "SaveJobButton";